module.exports = __webpack_public_path__ + "img/follow.891a72f6.svg";